export default __webpack_public_path__ + "static/media/Aura-Egg__97.0f518ef5.png";